import { api } from ".";

export interface InboundWebhookProviderResponse {
  Id: number;
  InboundWebhookSecurityTypeId: number;
  InboundWebhookProviderTypeId: number;
  Description: string;
  ProviderUrl?: string;
}

export interface InboundWebhookProviderModel {
  InboundWebhookSecurityTypeId: number;
  InboundWebhookProviderTypeId: number;
  Description: string;
  ProviderUrl?: string;
}

export enum InboundWebhookSecurityTypeEnum {
  ApiKey = 1,
  OAuth2 = 2,
  Svix = 3,
}

export enum InboundWebhookProviderTypeEnum {
  OCR = 1,
  Manual = 2,
}

const webhookProvidersUrlV1 = "/v1/InboundWebhookProviders";

export const getAllActiveInboundWebhookProviders = async (): Promise<InboundWebhookProviderResponse[]> => {
  const response = await api.get<InboundWebhookProviderResponse[]>(webhookProvidersUrlV1);
  return response?.data || [];
};

export const getInboundWebhookProviderById = async (id: number): Promise<InboundWebhookProviderResponse> => {
  const response = await api.get<InboundWebhookProviderResponse>(`${webhookProvidersUrlV1}/${id}`);
  return response?.data;
};

export const createInboundWebhookProvider = async (model: InboundWebhookProviderModel): Promise<InboundWebhookProviderResponse> => {
  const response = await api.post<InboundWebhookProviderResponse>(webhookProvidersUrlV1, model);
  return response?.data;
};

export const updateInboundWebhookProvider = async (id: number, model: InboundWebhookProviderModel): Promise<boolean> => {
  const response = await api.put(`${webhookProvidersUrlV1}/${id}`, model);
  return response?.status === 204;
};

export const deleteInboundWebhookProvider = async (id: number): Promise<boolean> => {
  const response = await api.delete(`${webhookProvidersUrlV1}/${id}`);
  return response?.status === 200 || response?.status === 204;
};
